<template>
	<div class="web-home">

        <!-- banner -->
        <oneBanner></oneBanner>

        <!-- 优势特点 -->
        <twoAdvantages></twoAdvantages>

        <!-- 人事管理 费用报销 -->
        <threeSwiper></threeSwiper>

        <!-- 线上线下一站式解决方案 -->
        <fourOnlineOffline></fourOnlineOffline>

        <!-- 最新资讯 -->
        <fiveLatestNews></fiveLatestNews>

        <!-- 协作发展 共赢未来 -->
        <sixCompanyIcon></sixCompanyIcon>

        <!-- 预约演示 -->
        <sevenReservation></sevenReservation>

        <!-- <iframe src="/ciic/index.html" id="mainIframe" ref="mainIframe" name="mainIframe"></iframe> -->
  	</div>
</template>

<script>
import oneBanner from './components/banner.vue'
import twoAdvantages from './components/advantages.vue'
import threeSwiper from './components/swiper.vue'
import fourOnlineOffline from './components/onlineOffline.vue'
import fiveLatestNews from './components/latestNews.vue'
import sixCompanyIcon from './components/companyIcon.vue'
import sevenReservation from './components/reservation.vue'

export default {
    components: { oneBanner, twoAdvantages, threeSwiper, fourOnlineOffline, fiveLatestNews, sixCompanyIcon, sevenReservation },

	data() {
		return {
			url: '',
		}
	},

	computed: {
      
    },

	created() {

	},

    mounted() {
    },

    methods: {
    }
}
</script>

<style lang="scss">
.web-home {
    width: 100%;
    // height: 100%;
    min-width: 1700px;
    iframe {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100%;
        border: 0;
    }

}
</style>

